import type { FailureCase } from "./failure-rules";

export interface OperationCoverage {
  operationId: string;
  relevant: number;
  covered: number;
  percentage: number;
}

export interface CoverageSummary {
  perOperation: OperationCoverage[];
  overall: { relevant: number; covered: number; percentage: number };
}

/**
 * Mide la cobertura negativa (P8-R4): de los casos de fallo que el visitante
 * aceptó como relevantes (`accepted`), qué proporción fue explícitamente
 * revisada (`reviewed`). Un caso inferido por el motor (`assumption: true`)
 * cuenta solo cuando un humano lo confirmó; así la métrica nunca se infla con
 * suposiciones sin validar.
 */
export function computeCoverage(casesByOperation: Map<string, FailureCase[]>): CoverageSummary {
  const perOperation: OperationCoverage[] = [];
  let totalRelevant = 0;
  let totalCovered = 0;

  for (const [operationId, cases] of casesByOperation) {
    const relevantCases = cases.filter((failureCase) => failureCase.accepted);
    const coveredCases = relevantCases.filter((failureCase) => failureCase.reviewed);
    const relevant = relevantCases.length;
    const covered = coveredCases.length;
    totalRelevant += relevant;
    totalCovered += covered;
    perOperation.push({
      operationId,
      relevant,
      covered,
      percentage: relevant === 0 ? 100 : Math.round((covered / relevant) * 100),
    });
  }

  return {
    perOperation,
    overall: {
      relevant: totalRelevant,
      covered: totalCovered,
      percentage: totalRelevant === 0 ? 100 : Math.round((totalCovered / totalRelevant) * 100),
    },
  };
}
